<div class="drawer-content" [ngClass]="{ 'iphone-style': isIphone }">
  <header class="title-area">
    <app-titulo [titulo]="titulo"></app-titulo>
    <mat-icon
      class="close-icon"
      aria-hidden="false"
      aria-label="Example home icon"
      fontIcon="close"
      (click)="cancelar()"></mat-icon>
  </header>
  <!-- <p class="subtitle-text">
  Envianos un mail a
  <a class="email-link"> atentic&#64;cuatroplus.com </a>
  o completa el siguiente formulario y nuestro equipo de especialistas te dará
  soporte:
</p> -->
  @if (modalFormHomeService.showingModalHome | async) {
    <div class="form-area">
      <app-form-mensaje-soporte #form></app-form-mensaje-soporte>
    </div>
  }
  <div class="bottom-area">
    <div class="actions">
      <app-button-primary
        class="button"
        (clicked)="enviar()"
        [disabled]="disabledButton()"
        [spinner]="isLoading"
        width="100%"
        [label]="labelPrimaryButton">
      </app-button-primary>
      <app-button-secondary
        class="button"
        [disabled]="false"
        (clicked)="cancelar()"
        width="100%"
        [label]="labelSecundaryButton">
      </app-button-secondary>
    </div>
    <app-error-message [showError]="error" [error]="error"> </app-error-message>
  </div>
</div>
